/* RESPONSIBLE TEAM: team-billing */

export default [
  'AU', // Australia
  'CA', // Canada
  'CH', // Switzerland
  'LI', // Liechtenstein
  'MY', // Malaysia
  'NO', // Norway
  'NZ', // New Zealand
];
